module.exports = __webpack_public_path__ + "img/review-bg.74d6b988.png";